/**
 *
 * @param range An object containing the min and max values of the dataset
 * @param scaleToRange An object containing the min and max output values
 * @returns (value: number) => location in range given a value in the range
 *
 * const fn = scaleLinear({ min: 0, max: 10 }, { min: 0, max: 100 })
 * fn(5) // 50
 * fn(1) // 10
 * fn(7) // 70
 */
const scaleLinear = (
  range: { min: number; max: number },
  scaleToRange: { min: number; max: number } = { min: 0, max: 100 }
) => {
  const rangeDelta = range.max - range.min;
  const scaleToRangeDelta = scaleToRange.max - scaleToRange.min;
  const ratio = scaleToRangeDelta / rangeDelta;

  return (value: number) => {
    const valueDelta = value - range.min;
    const scaledValue = valueDelta * ratio + scaleToRange.min;

    if (isNaN(scaledValue) || !isFinite(scaledValue)) {
      return 0;
    }

    return scaledValue;
  };
};

export { scaleLinear };
